import { brand } from '../../theme/themePrimitives';
import FileItemComponent from './file_component';
import FolderItemComponent from './folder_component';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { Folder, InsertDriveFile } from '@mui/icons-material';

const CreatedDocumentComponent = ({ setUploadFile, search, sort }: { setUploadFile: () => void, search: string, isAssigned: boolean, sort: boolean }) => {
    const { folders } = useSelector((state: RootState) => state.folder);
    const { files } = useSelector((state: RootState) => state.file);
    const filteredFolders = folders.filter((folder) => folder.name.toLowerCase().includes(search.toLowerCase()));
    const sortedFolders = sort ? [...filteredFolders].sort((a, b) => a.name.localeCompare(b.name)) : filteredFolders;
    const filteredFiles = files.filter((file) => file.file_name.toLowerCase().includes(search.toLowerCase()));
    const sortedFiles = sort ? [...filteredFiles].sort((a, b) => a.file_name.localeCompare(b.file_name)) : filteredFiles;

    return (
        <>
            <Box minHeight="30vh" maxHeight="30vh" mt={1} py={2}>
                <Box display="flex" alignItems="center" gap={2}>
                    <Typography maxWidth="none !important" width="max-content !important" variant="h6" color="textSecondary">
                        {/* {isAssigned ? 'Assigned Folders' : currentUser?.role === 'client' ? 'Created Folders' : 'Folders'} */}
                        Folders
                    </Typography>
                    {/* <Typography component="span" variant="subtitle2" color={brand[300]}>
                        {isAssigned
                        ? `You have ${filteredFolders.length} folders assigned to you`
                        : currentUser?.role === 'client'
                        ? `You have created ${filteredFolders.length} folders`
                        : ''}
                    </Typography> */}
                </Box>
                <Box display="flex" alignItems="center" gap={2} overflow="auto" py={1}>
                    {
                        sortedFolders.length === 0
                        ? <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" height="100%">
                            <Typography variant="subtitle1" color="textSecondary">No folder to display add new folder to view</Typography>
                            <Folder sx={{
                                fontSize: '200px',
                                color: brand[100],
                                marginTop: '10px'
                            }} />
                        </Box>
                        : sortedFolders.map((folder, index) => <Box key={index}>
                            <FolderItemComponent folder={folder} setUploadFile={setUploadFile} />
                        </Box>)
                    }
                </Box>
            </Box>
            <Box minHeight="30vh" maxHeight="30vh">
                <Box display="flex" alignItems="center" gap={2} >
                    <Typography maxWidth="none !important" width="max-content !important" variant="h6" color="textSecondary">
                        {/* {isAssigned ? 'Assigned Files' : currentUser?.role === 'client' ? 'Created Files' : 'Files'} */}
                        Files
                    </Typography>
                    {/* <Typography variant="subtitle2" color={brand[300]}>
                        {isAssigned
                        ? `You have ${filteredFiles.length} files assigned to you`
                        : currentUser?.role === 'client'
                        ? `You have created ${filteredFolders.length} files`
                        : ''}
                    </Typography> */}
                </Box>
                <Box display="flex" alignItems="center" gap={2} overflow="auto" py={1}>
                    {
                        sortedFiles.length === 0
                        ? (
                            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" height="100%">
                            <Typography variant="subtitle1" color="textSecondary">No document to display add new document to view</Typography>
                            <InsertDriveFile sx={{
                                fontSize: '200px',
                                color: brand[100],
                                marginTop: '10px'
                            }} />
                        </Box>
                        )
                        : sortedFiles.map((file, index) => <Box key={index}>
                            <FileItemComponent file={file} />
                        </Box>)
                    }
                </Box>
            </Box>
        </>
    );
};

export default CreatedDocumentComponent;